import { BaseRequest } from './BaseRequest';

export class SetAiAgentsPlanRequest extends BaseRequest {
    OrganizationId: string;
    Plan: string;
}